import React from "react";
import { Button, MessageBanner } from "@folio/stripes/components";
import { useIntl } from "react-intl";
/**
 * Controls of an asynchronous report next to its generate button: „Stáhnout"
 * once the file is ready, and a warning with „Zkusit znovu" while the job
 * status cannot be read (the job is kept and polled further).
 */
export var ReportJobDownload = function (_a) {
    var reportJob = _a.reportJob;
    var formatMessage = useIntl().formatMessage;
    if (!reportJob)
        return null;
    return (React.createElement(React.Fragment, null,
        reportJob.statusUnknown && (React.createElement(MessageBanner, { type: "warning" },
            formatMessage({
                id: "ui-br-agency.outputs.report-job.error.status",
            }),
            " ",
            React.createElement(Button, { buttonStyle: "default", onClick: reportJob.onRetryStatus, marginBottom0: true }, formatMessage({
                id: "ui-br-agency.outputs.report-job.button.retry",
            })))),
        reportJob.isDone && (React.createElement(Button, { buttonStyle: "success", onClick: reportJob.onDownload, disabled: reportJob.isDownloading, marginBottom0: true }, formatMessage({
            id: "ui-br-agency.outputs.report-job.button.download",
        })))));
};
